import { render, staticRenderFns } from "./HKLGrayHint.vue?vue&type=template&id=34ab8ad3&scoped=true&"
import script from "./HKLGrayHint.vue?vue&type=script&lang=js&"
export * from "./HKLGrayHint.vue?vue&type=script&lang=js&"
import style0 from "./HKLGrayHint.vue?vue&type=style&index=0&id=34ab8ad3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab8ad3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ab8ad3')) {
      api.createRecord('34ab8ad3', component.options)
    } else {
      api.reload('34ab8ad3', component.options)
    }
    module.hot.accept("./HKLGrayHint.vue?vue&type=template&id=34ab8ad3&scoped=true&", function () {
      api.rerender('34ab8ad3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/HKLGrayHint.vue"
export default component.exports